module.exports = __webpack_public_path__ + "media/images/avatars/null_male-58b902dff01a2f50b942366ca9ef8855.png";